import { getAbTestV2 } from 'dibs-ab-tests/exports/clientAbTestV2';

export const TEST_NAME = 'loggedInPasswordReset';

export function checkIsLoggedInPasswordResetTestVariant(): boolean {
    return getAbTestV2(TEST_NAME)?.variant === 'variant';
}
